import {Button, Form, Modal} from "react-bootstrap";
import {BsHeartbreak} from "react-icons/bs";
import {useContext, useEffect, useState} from "react";
import AppContext from "../AppContext";
import {useTranslation} from "react-i18next";
import './ExtraVideosPopup.scss'
import {IoExtensionPuzzleOutline} from "react-icons/io5";

export default function ExtraVideosPopup() {
    const app = useContext(AppContext)
    const [shown, setShown] = useState(false)
    const [checkbox, setCheckbox] = useState(false)
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (!app.user?.ID) return;

        if (!app.user.extra_videos_new?.length) {
            setShown(false);
            return;
        }

        // User chose "don't show again today"
        if (localStorage.getItem(dismissedKey(app.user.ID))) {
            setShown(false);
            return;
        }

        // Already shown once today
        if (sessionStorage.getItem(shownKey(app.user.ID))) {
            setShown(false);
            return;
        }

        // First time today
        setShown(true);
    }, [app.user?.ID, app.user?.extra_videos_new?.length]);
    const today = new Date().toLocaleDateString("en-CA");
    const dismissedKey = (userId) => `extra-videos-dismissed-${userId}-${today}`;
    const shownKey = (userId) => `extra-videos-popup-shown-${userId}-${today}`;
    const closePopup = () => {
        if (checkbox) {
            localStorage.setItem(dismissedKey(app.user.ID), "1");
        }
        sessionStorage.setItem(shownKey(app.user.ID), "1");
        setCheckbox(false);

        setShown(false);
    };
    const handleCheckbox = (e) => {
        setCheckbox(e.target.checked)
    }

    const hidePopup = () => {
        setCheckbox(false);

        setShown(false);
    }
    const goToVideos = () => {
        closePopup()
        setTimeout(() => window.location.href = '/extra-videos', 1000)
    }
    return <Modal show={shown} onHide={hidePopup} className="extra-videos-modal">
        <Modal.Header closeButton className="px-4">
            <Modal.Title>
                <IoExtensionPuzzleOutline />
                <strong>{t('extraVideos.popup.title')}</strong>
                <span>{t('extraVideos.popup.subtitle')}</span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pt-4">
            <div>
                {t('extraVideos.popup.text1')}
            </div>
            <Form>
                <div className="mb-3 mt-5">
                    <small>
                        <Form.Check
                            name="dismiss"
                            type="checkbox"
                            id="extra-videos-modal-dismiss-check"
                            label={t('extraVideos.popup.checkbox')}
                            checked={checkbox}
                            value="1"
                            onChange={handleCheckbox}
                        />
                    </small>
                </div>
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={closePopup}>
                {t('extraVideos.popup.cancel')}
            </Button>
            <Button variant="info" onClick={goToVideos}>
                {t('extraVideos.popup.go')}
            </Button>
        </Modal.Footer>
    </Modal>
}